import React from 'react'
import LeftBar from '../Components/LeftBar'
import Dashnav from '../Components/Dashnav'
import ProfileComp from './ProfileComp'

function Profile() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <ProfileComp/>      
        </div>
    </div>
  )
}

export default Profile